import React from 'react';
import { Button, Flex, NumericInput, PropertyGrid, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { ModelTypeSelector } from '@leverege/ui-plugin';
import ThresholdModel from "../models/ThresholdModel.js";
import Thresholdizers from "../attribute/Thresholdizers.js";
const {
  t,
  tIcon
} = I18N.ns('ui-attributes-graphs.editors.ThresholdEditor');
export default function ThresholdsEditor(props) {
  const {
    value,
    eventData,
    model,
    objectType,
    onChange: pOnChange,
    ...rest
  } = props;
  const thresholds = model.getAll(value);
  return thresholds.map((threshold, index) => {
    const onChange = ({
      data,
      value: t
    }) => {
      const nModel = ThresholdModel[data](threshold, t);
      pOnChange({
        data: eventData,
        value: model.set(value, index, nModel)
      });
    };
    const onRemove = ({
      data
    }) => {
      pOnChange({
        data: eventData,
        value: model.removeAt(value, data)
      });
    };
    return /*#__PURE__*/React.createElement(Flex, {
      key: value?.id,
      justify: "space-between",
      align: "center"
    }, /*#__PURE__*/React.createElement(PropertyGrid, null, /*#__PURE__*/React.createElement(PropertyGrid.Subheader, {
      title: `${t('threshold')} ${index + 1}`
    }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
      label: t('color')
    }, /*#__PURE__*/React.createElement(TextInput, {
      value: ThresholdModel.getColor(threshold),
      onChange: onChange,
      eventData: "setColor"
    })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
      label: t('opacity')
    }, /*#__PURE__*/React.createElement(NumericInput, {
      min: 0,
      max: 1,
      float: true,
      value: ThresholdModel.getOpacity(threshold),
      onChange: onChange,
      eventData: "setOpacity"
    })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
      label: t('width')
    }, /*#__PURE__*/React.createElement(TextInput, {
      value: ThresholdModel.getWidth(threshold),
      onChange: onChange,
      eventData: "setWidth"
    })), ModelTypeSelector.createSelectorAndEditor({
      values: Thresholdizers.getThresholdizersFor(objectType),
      value: ThresholdModel.getValue(threshold),
      eventData: 'setValue',
      onChange,
      allowNone: false,
      modelKey: 'thresholdizer',
      isPropertyGrid: true,
      label: t('value'),
      propertyGridOpts: {
        inline: true
      },
      editorProps: {
        ...rest,
        objectType,
        parentValue: value
      }
    })), /*#__PURE__*/React.createElement(Button, {
      eventData: index,
      variant: "tertiaryIconic",
      icon: tIcon('delete', 'fa fa-times fa-fw'),
      onClick: onRemove
    }));
  });
}